module.exports = __webpack_public_path__ + "static/media/reducer-ref.6ff57d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/reducer-ref.png
// module id = 83
// module chunks = 0